import type { PropsWithChildren, ReactElement } from 'react';

export function ConditionalWrapper({
  condition,
  children,
}: PropsWithChildren<{ condition: boolean }>): ReactElement | null {
  if (!condition) {
    return null;
  }

  return <>{children}</>;
}
